<template>
    <v-list expand>
        <v-list-group
            :value="true"
            :ripple=false
            color="black"
        >
            <template v-slot:activator>
                <v-list-item two-line>
                    <v-list-item-content class="pa-0">
                        <v-list-item-title>
                            <TitleSection
                                class="text-none"
                                :section="section"
                            />
                        </v-list-item-title>
                        <v-list-item-subtitle class="habiteo-body-2">
                            {{ radioTitle }}
                        </v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
            </template>

            <v-radio-group
                :id="gtmTrackerId"
                v-model="radioValue"
                class="ma-0"
                :class="{'descending': orientation == 'desc'}"
                hide-details
            >
                <v-radio
                    name="active"
                    class="ma-0 habiteo-body-2"
                    v-for="(filterItem , index) in filterData"
                    :key="filterItem.text + '-' + index"
                    :label="`${filterItem.text}`"
                    :value="index"
                    :ripple=false
                    @click.prevent="filterBy(filterItem)"
                />
            </v-radio-group>
        </v-list-group>
    </v-list>
</template>

<script>
    import TitleSection from "@/components/filters/TitleSection";

    export default {
        name: "RadioButton",
        components: {
            TitleSection
        },
        props: {
            orientation: {
                type: String,
            },
            currentFloor: {
                type: Number,
                required: true,
            },
            filterData: {
                type: [Object, Array],
                required: true,
            },
            section: {
                type: String,
                required: true,
            }
        },
        computed: {
            radioValue: {
                get: function() {
                    return this.currentFloor;
                },
                set: function(value) {
                    return value
                }
            },
            radioTitle() {
                return this.$t(`sidebar.section.${this.section}Subtitle`);
            },
            gtmTrackerId() {
                return `gtm-filter-${this.section}`;
            }
        },
        methods: {
            filterBy(filter) {
                this.$emit('select-method', filter);
            }
        }
    }
</script>

<style lang="scss">
    @import "@/assets/scss/_common.scss";
    
    .descending {
        .v-input__control {
            .v-input__slot {
                .v-input--radio-group__input {
                    flex-direction: column-reverse;
                }
            }
        }   
    }
</style>



// WEBPACK FOOTER //
// src/components/filters/RadioButton.vue